import { FeatureFlags } from '@/modules/featureFlags';

import { useFeatureFlag } from './useFeatureFlag';

export const useIsFraudPaymentHoldAvailable = (): boolean =>
  useFeatureFlag(FeatureFlags.FRAUD_PAYMENT_HOLD);
